import { accountPaths } from "./account";
import { appPaths } from "./app";
import { authPaths } from "./auth";
import { flowPaths } from "./flows";
import { insurancePaths } from "./insurance";
import { wyshesPaths } from "./wyshes";

export { RoutePath } from "./routePath";
export { authPaths } from "./auth";
export { accountPaths } from "./account";
export { insurancePaths } from "./insurance";
export { wyshesPaths } from "./wyshes";
export { flowPaths } from "./flows";
export { appPaths } from "./app";

export const Paths = {
  ...authPaths,
  account: accountPaths,
  ...insurancePaths,
  ...wyshesPaths,
  ...flowPaths,
  ...appPaths,
};
